import { FC } from 'react';
import { FlagIcon, PeopleIcon, PersonIcon, InfoIcon } from 'assets/images/resourceCenter';
import clsx from 'clsx';
import { useStyles } from './ResourceCard.styles';

export enum ResourceType {
  Person = 'Person',
  People = 'People',
  Info = 'Info',
}

export interface Resource {
  id: string;
  name: string;
  description: string;
  image: string;
  isProfile: boolean;
  type: ResourceType;
  tag: string;
}

export interface ResourceCardProps {
  item: Resource;
}

const Icon: FC<ResourceCardProps> = ({ item: { type } }) => {
  const styles = useStyles();
  let component;
  switch (type) {
    case ResourceType.Info:
      component = <img src={InfoIcon} alt="flag-icon" className={styles.infoIcon} />;
      break;
    case ResourceType.People:
      component = <img src={PeopleIcon} alt="flag-icon" className={styles.peopleIcon} />;
      break;
    case ResourceType.Person:
      component = <img src={PersonIcon} alt="flag-icon" className={styles.personIcon} />;
      break;
    default:
      component = undefined;
      break;
  }

  return <>{component}</>;
};

export const ResourceCard: FC<ResourceCardProps> = (props) => {
  const styles = useStyles();
  const { item } = props;
  let titleStyle;
  let descriptionStyle;
  let descriptionContainerStyle;
  let flagButtonStyle;

  if (item.isProfile) {
    titleStyle = clsx(styles.title, styles.titleProfile);
    descriptionStyle = clsx(styles.description, styles.descriptionProfile);
    descriptionContainerStyle = styles.containerDescriptionProfile;
    flagButtonStyle = clsx(styles.flagButton, styles.flagButtonProfile);
  } else {
    titleStyle = clsx(styles.title, styles.titleResource);
    descriptionStyle = clsx(styles.description, styles.descriptionResource);
    descriptionContainerStyle = styles.containerDescriptionResource;
    flagButtonStyle = styles.flagButton;
  }

  return (
    <div className={styles.container}>
      <div className={styles.containerContent}>
        <div className={styles.containerBody}>
          <div className={clsx(styles.wrapperImage, item.isProfile ? styles.wrapperProfileImage : undefined)}>
            <img src={item.image} alt="resource" className={clsx(item.isProfile ? styles.profileImage : styles.resourceImage, styles.image)} />
          </div>
          <div className={styles.containerTitle}>
            <span className={titleStyle}>{item.name}</span>
          </div>
          <div className={descriptionContainerStyle}>
            <span className={descriptionStyle}>{item.description}</span>
          </div>
        </div>
      </div>
      <div className={styles.containerFooterButtons}>
        <div className={styles.containerLeftIcons}>
          <Icon {...props} />
          <div className={styles.tag}>
            <span className={styles.titleTag}>{item.tag}</span>
          </div>
        </div>
        <button type="button" className={flagButtonStyle}>
          <img src={FlagIcon} alt="flag-icon" className={styles.flagIcon} />
        </button>
      </div>
    </div>
  );
};
